import { Component, Input, OnChanges, OnInit, viewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Campaign, StaffCampaignStrategy, TimeLimitRule } from 'src/app/api/api-campaigns.service.generated';
import { DateUtils } from 'src/app/common/utils/DateUtils';
import { ConsumptionFiltersEditComponent } from '../../_/consumption-filters-edit/consumption-filters-edit.component';
import { RewardSelectComponent } from '../../_/reward-select/reward-select.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FlexLayoutModule } from '@angular/flex-layout';

@Component({
    selector: 'app-staff-campaign-strategy',
    templateUrl: './staff-campaign-strategy.component.html',
    styleUrls: ['./staff-campaign-strategy.component.scss'],
    imports: [
      ReactiveFormsModule,
      MatFormFieldModule,
      MatInputModule,
      FlexLayoutModule,
      ConsumptionFiltersEditComponent,
      RewardSelectComponent
    ]
})
export class StaffCampaignStrategyComponent implements OnInit, OnChanges {

  @Input() strategy: StaffCampaignStrategy;
  @Input() advertiserId: string;

  readonly filters = viewChild<ConsumptionFiltersEditComponent>('filters');
  readonly serviceReward = viewChild<RewardSelectComponent>('serviceReward');

  campaigns: Campaign[];

  form = new FormGroup({
    // staff campaign strategy
    coinMultiplier: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
    minScore : new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),

    // time limit
    timeLimitMaxLimit: new FormControl(''),
    timeLimitInterval: new FormControl(''),
  });


  constructor() { }

  ngOnChanges(): void {
    if (!this.strategy) return;
    setTimeout(() => {
      this.setFormValue(this.strategy);
    }, 0);
  }


  async ngOnInit() {
  }

  setFormValue(model: StaffCampaignStrategy) {
    this.form.patchValue({
      ...model,

      // time limit
      timeLimitMaxLimit: (model.timeLimit && model.timeLimit.maxLimit.toString()) || '',
      timeLimitInterval: (model.timeLimit && model.timeLimit.interval) || '',
    });

    this.filters().setFormValue(model.consumptionFilters);
    this.serviceReward().setFormValue(model.serviceReward);
  }

  getFormValue() {
    const filters = this.filters();
    if (!filters.isValid()) return null;

    if (!this.form.valid) {
      this.forceValidatorsToDisplayErrors();
      return null;
    }
    const f = this.form.value;

    const model = new StaffCampaignStrategy ({
      ...this.strategy,
      name: 'StaffObsolete',
      coinMultiplier : +f.coinMultiplier,
      minScore : +f.minScore,

      // time limit
      timeLimit: f.timeLimitMaxLimit && f.timeLimitInterval
          ? new TimeLimitRule({ maxLimit: +f.timeLimitMaxLimit, interval: f.timeLimitInterval })
          : undefined,

      consumptionFilters: filters.getFormValue(),
      serviceReward: this.serviceReward().getFormValue()
    });

    return model;
  }

  forceValidatorsToDisplayErrors() {
    // force validators to display errors
    Object.keys(this.form.controls).forEach(key => {
      this.form.get(key).markAsTouched();
      this.form.get(key).markAsDirty();
    });

    this.filters().forceValidatorsToDisplayErrors();
  }

  async onSubmit() {
  }

  displayDuration(duration: string) {
    return DateUtils.displayCsDuration(duration);
  }


}
